import { render, staticRenderFns } from "./ModalClose.vue?vue&type=template&id=362e2dab"
import script from "./ModalClose.vue?vue&type=script&lang=js"
export * from "./ModalClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports